<template lang="pug">
  .layout-public-header(v-if="$vuetify.breakpoint.smAndDown" :class="{'bg-color-is': scrollPosition > 50}")
    v-container
      router-link(target="_self" :to="'/'")
        img(:src="icons.logo" :srcset="icons.logo" width="130px" alt="Logo Interseguro")
</template>

<script>
export default {
  data () {
    return {
      icons: {
        logo: require('@/assets/logo.svg')
      },
      scrollPosition: null
    }
  },
  methods: {
    updateScroll () {
      this.scrollPosition = window.scrollY
    }
  },
  mounted () {
    window.addEventListener('scroll', this.updateScroll)
  }
}
</script>

<style>

.layout-public-header {
  background-color: rgba(255, 255, 255, 0.10);
  position: fixed;
  padding: 15px 0;
  width: 100%;
  transition: all 0.4s ease-out;
  z-index: 1;
}

.layout-public-header.bg-color-is {
  background-color: var(--first-brand-color);
}

.layout-public-header .container {
  padding: 0 !important;
}

.layout-public-header a {
  display: flex;
}

@media screen and (max-width: 1024px) {
  .layout-public-header .container {
    margin-left: auto;
    margin-right: auto;
    width: 90%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login/Navbar.vue